import {
  Asset as AmbassadorAsset,
  Template as AmbassadorTemplate,
  Type as AssetType,
  QueryTemplatesRequest,
  QueryTemplatesResponse,
} from '@wix/ambassador-funnel-templates-gallery-v2-template/types';
import { BLANK_TEMPLATE_META_SITE_ID } from '../../config';
import type {
  QueryTemplatesParams,
  TemplatesResponse,
} from '../repositories/proto/ITemplateRepository';

export interface Asset {
  absoluteUrl: string;
  alt: string;
  type: AssetType;
}

export interface Template {
  templateId: string;
  title: string;
  metaSiteId: string;
  description: string;
  slug: string;
  assets: Asset[];
  categoryId?: string;
}

export function mapAmbassadorAsset(asset: AmbassadorAsset): Asset {
  return {
    absoluteUrl: asset.absoluteUrl!,
    alt: asset.alt!,
    type: asset.type!,
  };
}

export function mapAmbassadorTemplate(template: AmbassadorTemplate): Template {
  return {
    templateId: template.templateId!,
    description: template.description!,
    title: template.title!,
    metaSiteId: template.metaSiteId!,
    slug: template.slug!,
    assets: template.assets?.map<Asset>(mapAmbassadorAsset) ?? [],
  };
}

export const isBlankTemplate = (template: Template) => {
  return template.metaSiteId === BLANK_TEMPLATE_META_SITE_ID;
};

export const mapQueryParams = ({
  language,
  limit,
  offset,
  templateBuilders,
  categoryId,
  query,
}: QueryTemplatesParams): QueryTemplatesRequest => {
  const req: QueryTemplatesRequest = {
    space: 'studio',
    language,
    limit,
    offset,
  };
  if (categoryId) {
    req.categoryIds = [categoryId];
  }
  if (query) {
    req.search = query.slice(0, 100);
  }
  if (templateBuilders?.length) {
    // this can cause issues if more filters are added
    req.filter = { templateBuilder: templateBuilders };
  }
  return req;
};

export const mapQueryResponse = (
  res: QueryTemplatesResponse,
): TemplatesResponse => ({
  templates: res.templates?.map(mapAmbassadorTemplate) || [],
  total: res.pagingMetadata?.total || 0,
  offset: res.pagingMetadata?.offset || 0,
});
